export default function ResultWrapper({ children }) {
	return <div className="ResultWrapper">{ children}</div>
}
